import React, { useContext, useEffect, useState } from "react";
import { MsalContext } from '../Contexts/MsalContext';
import ComplaintResponseViewModel from "./ViewModel/ComplaintResponseViewModel";
import Grid from "@mui/material/Grid";
import Action from "./Action";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Tooltip from "@mui/material/Tooltip";

interface IActionsProps {
    systemPK: string,
}

export default function ActionSelector({ systemPK }: IActionsProps) {
    const { msalFetch } = useContext(MsalContext);
    const [message, setMessage] = useState<string>("");
    const [complaints, setComplaints] = useState<ComplaintResponseViewModel[]>([]);
    const [index, setIndex] = useState<number>(0);

    useEffect(() => {
        if (systemPK) {
            getComplaints();
        }
    }, [systemPK])

    const getComplaints = () => {
        msalFetch('api/IssueReview/GetComplaintsList?SystemPK=' + encodeURIComponent(systemPK))
            .then((response) => response.json())
            .then((data: ComplaintResponseViewModel[]) => {
                if (data.length == 0)
                    setMessage("No Complaints Found");
                else {
                    setComplaints(data);
                    setIndex(0);
                }
            });
    }

    return (
        <React.Fragment>
            {complaints.length > 0 ?
                <Grid container>
                    <Grid size={12}>
                        <Typography style={{ paddingBottom: '8px', paddingRight: '8px', textAlign: 'right' }}>
                            Current Page {index + 1} of {complaints.length}
                        </Typography>
                    </Grid>
                    <Grid size={1}>
                        <Tooltip title="Previous Action">
                            <Button fullWidth color="primary"
                                style={{ height: '-webkit-fill-available' }}
                                disabled={index === 0}
                                onClick={() => { setIndex(index - 1) }}>
                                <KeyboardArrowLeftIcon />
                            </Button>
                        </Tooltip>
                    </Grid>
                    <Grid size={10}>
                        <Action
                            action={complaints[index]}
                            getComplaints={getComplaints} />
                    </Grid>
                    <Grid size={1}>
                        <Tooltip title="Next Action">
                            <Button fullWidth color="primary"
                                style={{ height: '-webkit-fill-available' }}
                                disabled={index === complaints.length - 1}
                                onClick={() => { setIndex(index + 1) }}>
                                <KeyboardArrowRightIcon />
                            </Button>
                        </Tooltip>
                    </Grid>
                </Grid>
                :
                <Typography>
                    {message}
                </Typography>
            }
        </React.Fragment>
    )
}